import React, { useRef, Ref } from "react";
import Nav from "./Nav";
import Mcxlist from "./watchlist/Mcxlist";
import Mcxwatchlist from "./watchlist/Mcxwatchlist";
import Nsclist from "./watchlist/Nsclist";
import { useState, useEffect } from "react";
import Nscwatchlist from "./watchlist/Nscwatchlist";
import axios from "axios";
import Modal from "react-modal";
import { useNavigate, Link } from "react-router-dom";
import Theme from "./Theme";
import { baseUrl, liveRateUrl } from "./constant.js";
import Allmarketwatch from "./watchlist/Allmarketwatch.js";
import Allmarket from "./watchlist/Allmarket.js";
import Others from "./watchlist/Others";
import Extra from "./watchlist/extra.js";
import Logoutmodule from "./logout/Logoutmodule";
import Allmarketpopup from "./Allmarketpopup.js";
import Popup from "./Popup.js";
import Optionchain from "./optionchain/Optionchain.js";
import Mcxnfo from "./watchlist/niftyoption.js";
import Banknifty from "./watchlist/bankniftyoption.js";

const getSearchPopupTheme = () => {
  const stored = localStorage.getItem("background") || "light";
  const legacy = { 0: "dark", 1: "light", 2: "green" };
  const key = legacy[stored] || stored;
  if (key === "dark") {
    return {
      overlay: "rgba(2, 6, 23, 0.72)",
      bg: "#1e293b",
      text: "#ffffff",
      muted: "#94a3b8",
      border: "#334155",
      itemBg: "#334155",
      accent: "#f59e0b",
      closeBg: "#0f172a",
    };
  }
  if (key === "green") {
    return {
      overlay: "rgba(6, 74, 60, 0.55)",
      bg: "#1e5655",
      text: "#ffffff",
      muted: "#efda95",
      border: "#36474f",
      itemBg: "#164544",
      accent: "#b28e4d",
      closeBg: "#064a3c",
    };
  }
  return {
    overlay: "rgba(6, 74, 60, 0.28)",
    bg: "#ffffff",
    text: "#064a3c",
    muted: "#5a7a88",
    border: "#d7e8f0",
    itemBg: "#edf9fe",
    accent: "#1b715f",
    closeBg: "#f0f7fb",
  };
};

const Home = (index) => {
  const [data, setData] = useState([]);
  const [activeSearchBar, setActiveSearchBar] = useState(7);
  const [live, setlive] = useState([]);
  const [previousPrice, setPreviousPrice] = useState(null);
  const [currentPrice, setCurrentPrice] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [isRunning, setIsRunning] = useState(true);
  const [allmarketpopup, setallmarketpopup] = useState(0);
  const [isOpen, setIsOpen] = useState(true);
  // console.log(live);
  // console.log(data);
  const openModal = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    // setIsOpen(false);
    setallmarketpopup(0);
  };

  const navigate = useNavigate();
  const getdata = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      return;
    }
    const formdata = new FormData();
    formdata.append("Token", token);
    try {
      const result = await axios.post(
        baseUrl + "authController/getMcxCategoryList",
        formdata,
      );

      if (result.data.is_login === 0) {
        localStorage.removeItem("Name");
        localStorage.removeItem("userCode");
        localStorage.removeItem("token");
        navigate("/login");
        return;
      }
      const result1 = Array.isArray(result.data.data) ? result.data.data : [];
      result1.map((mapItem) => {
        if (mapItem.is_checked === 1) {
          localStorage.setItem(mapItem.instrument_token + "-Buy-Price", 0);
          localStorage.setItem(mapItem.instrument_token + "-Sell-Price", 0);
        }
      });

      setData(result1);
    } catch (error) {
      localStorage.removeItem("Name");
      localStorage.removeItem("userCode");
      localStorage.removeItem("token");
      navigate("/login");
    }
  };
  const Livedata = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      return;
    }
    const formdata = new FormData();
    formdata.append("Token", token);
    try {
      const liverate = await axios.post(liveRateUrl, formdata);
      setlive(
        Array.isArray(liverate.data.livedata) ? liverate.data.livedata : [],
      );
    } catch (error) {
      setlive([]);
    }
  };

  useEffect(() => {
    const auth = localStorage.getItem("token");
    if (!auth) {
      navigate("/login");
      return;
    }
    getdata();
    Livedata();
    // result5()
    const interverl = setInterval(() => {
      Livedata();
    }, 500);
  }, []);
  const mcx = data
    .filter((item) => item.instrument_type === "MCX")
    .filter((val) => {
      if (val.title.toLowerCase().includes(searchTerm.toLowerCase())) {
        return val;
      }
    });
  const nsc = data
    .filter((item) => item.instrument_type === "NSE")
    .filter((val) => {
      if (searchTerm == "") {
        return val;
      } else if (val.title.toLowerCase().includes(searchTerm.toLowerCase())) {
        return val;
      }
    });
  const Allmarketdatawatch = data.filter((item) => item.is_checked === 1);
  // console.log(Allmarketdatawatch);
  const mcxwatch = mcx.filter((item) => item.is_checked === 1);
  const nscwatch = nsc.filter((item) => item.is_checked === 1);
  const handleButtonClick = (searchBarNumber) => {
    setActiveSearchBar(searchBarNumber);
  };
  const stopFunctionCall = () => {
    setIsRunning(false);
  };

  const option = live.filter((optionitem) => optionitem.Exchange === "NFO-OPT");
  // console.log(option);

  const filterByType = (type) => {
    return option.filter((item) => item.InstrumentIdentifier.endsWith(type));
  };
  const ce = filterByType("CE");
  const pe = filterByType("PE");
  // console.log(ce);
  // console.log(pe);

  window.addEventListener("beforeunload", () => {
    localStorage.removeItem("background");
  });

  const popupTheme = getSearchPopupTheme();
  const searchPopupStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: popupTheme.overlay,
      zIndex: 2000,
      width: "100%",
      height: "100%",
      margin: 0,
      borderRadius: 0,
    },
    content: {
      position: "relative",
      top: "auto",
      left: "auto",
      right: "auto",
      bottom: "auto",
      inset: "auto",
      transform: "none",
      margin: "0 auto",
      width: "90%",
      maxWidth: 360,
      height: "auto",
      minHeight: 360,
      maxHeight: "75vh",
      padding: 0,
      border: `1px solid ${popupTheme.border}`,
      borderRadius: 16,
      background: popupTheme.bg,
      color: popupTheme.text,
      boxShadow: "0 18px 40px rgba(0,0,0,0.35)",
      overflow: "auto",
      WebkitOverflowScrolling: "touch",
    },
  };

  const exchangeOptions = [
    {
      label: "NSE Future",
      action: () => {
        handleButtonClick(4);
        closeModal();
      },
    },
    {
      label: "MCX Future",
      action: () => {
        handleButtonClick(3);
        closeModal();
      },
    },
    { label: "Option and Future", action: null },
    { label: "Global Future", action: null },
    { label: "Comex Future", action: null },
    { label: "Others", action: null },
  ];

  return (
    <>
      <section className="marketwatch_pg online_trade_view" key={index}>
        <div className="list_market_row text-center">
          <div className="onine_view_col">
            <div className="phone_frame">
              <div className="frame_screen">
                <div className="screen_body main_screenUI" id="card-box">
                  <div className="dashboard_main">
                    <div
                      className="dashboard_header"
                      style={{ justifyContent: "space-between" }}
                    >
                      {activeSearchBar === 3 && (
                        <Link
                          to=""
                          style={{ color: "white" }}
                          onClick={() => {
                            {
                              handleButtonClick(1);
                            }
                            {
                              getdata();
                            }
                            setSearchTerm("");
                          }}
                        >
                          <a href="/">
                            <i class="fa fa-angle-left"></i>
                          </a>
                        </Link>
                      )}
                      {activeSearchBar === 4 && (
                        <Link
                          to=""
                          style={{ color: "white" }}
                          onClick={() => {
                            {
                              handleButtonClick(2);
                            }
                            {
                              getdata();
                            }
                            setSearchTerm("");
                          }}
                        >
                          <a href="/">
                            <i class="fa fa-angle-left"></i>
                          </a>
                        </Link>
                      )}
                      {activeSearchBar !== 3 && activeSearchBar !== 4 && (
                        <Logoutmodule />
                      )}
                      <div>
                        <a
                          href="#"
                          data-bs-toggle="modal"
                          data-bs-target="#color_modal"
                        >
                          <img
                            src="assets/img/icons/colour.png"
                            className="img-fluid color_icons"
                          />
                        </a>
                      </div>
                    </div>
                    <div className="dashboard_col">
                      <div className="dashboard_tabs_colm">
                        <ul
                          className="dashboard_col_nav nav nav-tabs"
                          role="tablist"
                        >
                          <li className="nav-item">
                            <Link
                              to=""
                              className="nav-link"
                              href="#"
                              id="others"
                              data-bs-toggle="tab"
                              data-bs-target="#others-tabs"
                              type="button"
                              role="tab"
                              aria-controls="others-tabs"
                              aria-selected="true"
                              onClick={() => {
                                {
                                  handleButtonClick(7);
                                }
                                {
                                  getdata();
                                }
                              }}
                            >
                              ALL MARKET
                            </Link>
                          </li>

                          <li className="nav-item">
                            {" "}
                            <Link
                              to="/mcxwatchlist"
                              className="nav-link"
                              id="futures"
                              data-bs-toggle="tab"
                              type="button"
                              role="tab"
                              aria-controls="futures-tabs"
                              aria-selected="true"
                              onClick={() => {
                                {
                                  handleButtonClick(1);
                                }
                                {
                                  getdata();
                                }
                              }}
                            >
                              MCX
                            </Link>
                          </li>
                          <li className="nav-item">
                            {" "}
                            <Link
                              to="/nscwatchlist"
                              className="nav-link"
                              id="nse"
                              data-bs-toggle="tab"
                              type="button"
                              role="tab"
                              aria-controls="nse-tabs"
                              aria-selected="true"
                              onClick={() => {
                                {
                                  handleButtonClick(2);
                                }
                                {
                                  getdata();
                                }
                              }}
                            >
                              NSE
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              to=""
                              className="nav-link"
                              href="#"
                              id="others"
                              data-bs-toggle="tab"
                              data-bs-target="#others-tabs"
                              type="button"
                              role="tab"
                              aria-controls="others-tabs"
                              aria-selected="true"
                              onClick={() => {
                                {
                                  handleButtonClick(20);
                                }
                                {
                                  getdata();
                                }
                              }}
                            >
                              OPTION CHAIN
                            </Link>
                          </li>
                          {/* <select
                                value={7}
                                onChange={(e) =>
                                  handleButtonClick(e.target.value)
                                }
                              >
                                <option value="">OTHERS</option>
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                              </select> */}
                        </ul>{" "}
                      </div>
                      <div className="tab-content dashboard_col_tabs">
                        <div className="tab_search_body pb-0">
                          {activeSearchBar === 1 && (
                            <input
                              type="text"
                              name="search"
                              className="form-control"
                              placeholder="SEARCH & MCX"
                              onClick={() => {
                                {
                                  handleButtonClick(3);
                                }
                              }}
                            />
                          )}
                          {activeSearchBar === 2 && (
                            <input
                              type="text"
                              name="search"
                              className="form-control"
                              placeholder="SEARCH & NSE"
                              onClick={() => handleButtonClick(4)}
                            />
                          )}
                          {activeSearchBar === 7 && (
                            <input
                              type="text"
                              name="search"
                              className="form-control formcontrolsearch"
                              placeholder="SEARCH & ADD"
                              onClick={() => setallmarketpopup(1)}
                            />
                          )}
                          {allmarketpopup === 1 && (
                            <Modal
                              className="searchpopup"
                              portalClassName="searchpopup-portal"
                              isOpen={isOpen}
                              onRequestClose={closeModal}
                              style={searchPopupStyles}
                              contentLabel="Select Exchange"
                              ariaHideApp={false}
                            >
                              <div
                                className="searchpopup-inner"
                                style={{
                                  background: popupTheme.bg,
                                  color: popupTheme.text,
                                  padding: "14px 14px 16px",
                                  minHeight: 340,
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    marginBottom: 12,
                                    paddingBottom: 10,
                                    borderBottom: `1px solid ${popupTheme.border}`,
                                  }}
                                >
                                  <div style={{ textAlign: "left" }}>
                                    <h5
                                      style={{
                                        margin: 0,
                                        fontSize: 16,
                                        fontWeight: 700,
                                        color: popupTheme.text,
                                      }}
                                    >
                                      Select Exchange
                                    </h5>
                                    <p
                                      style={{
                                        margin: "4px 0 0",
                                        fontSize: 12,
                                        color: popupTheme.muted,
                                      }}
                                    >
                                      Choose market to search & add
                                    </p>
                                  </div>
                                  <button
                                    type="button"
                                    onClick={closeModal}
                                    style={{
                                      border: `1px solid ${popupTheme.border}`,
                                      background: popupTheme.closeBg,
                                      color: popupTheme.text,
                                      borderRadius: 8,
                                      width: 34,
                                      height: 34,
                                      fontSize: 18,
                                      lineHeight: 1,
                                      cursor: "pointer",
                                      padding: 0,
                                    }}
                                    aria-label="Close"
                                  >
                                    ×
                                  </button>
                                </div>

                                <ul
                                  className="no-bullets searchpopup-menu"
                                  style={{
                                    listStyle: "none",
                                    margin: 0,
                                    padding: 0,
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 8,
                                  }}
                                >
                                  {exchangeOptions.map((item) => (
                                    <li
                                      key={item.label}
                                      style={{ width: "100%" }}
                                    >
                                      <button
                                        type="button"
                                        className="searchpopup-item"
                                        onClick={() => {
                                          if (item.action) item.action();
                                        }}
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "space-between",
                                          width: "100%",
                                          textAlign: "left",
                                          background: popupTheme.itemBg,
                                          border: `1px solid ${popupTheme.border}`,
                                          borderRadius: 10,
                                          padding: "12px 14px",
                                          color: popupTheme.text,
                                          fontSize: 14,
                                          fontWeight: 600,
                                          cursor: "pointer",
                                        }}
                                      >
                                        <span
                                          style={{ color: popupTheme.text }}
                                        >
                                          {item.label}
                                        </span>
                                        <i
                                          className="fa fa-chevron-right"
                                          style={{
                                            color: popupTheme.accent,
                                            fontSize: 12,
                                          }}
                                        ></i>
                                      </button>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            </Modal>
                          )}

                          {activeSearchBar === 3 && (
                            <input
                              type="text"
                              name="search"
                              className="form-control"
                              placeholder="SEARCH & MCX"
                              onChange={(e) => setSearchTerm(e.target.value)}
                            />
                          )}
                          {activeSearchBar === 4 && (
                            <input
                              type="text"
                              name="search"
                              className="form-control"
                              placeholder="SEARCH & NSE"
                              onChange={(e) => setSearchTerm(e.target.value)}
                            />
                          )}
                        </div>
                        {activeSearchBar === 1 &&
                          mcxwatch.map((item1) => {
                            const matchingItem = live.find(
                              (item2) =>
                                item2.InstrumentIdentifier ==
                                item1.instrument_token,
                            );
                            return (
                              <Mcxwatchlist
                                changeprice={matchingItem?.PriceChange}
                                percentagepricechange={
                                  matchingItem?.PriceChangePercentage
                                }
                                buy={matchingItem?.BuyPrice}
                                sell={matchingItem?.SellPrice}
                                ltp={matchingItem?.LastTradePrice}
                                high={matchingItem?.High}
                                low={matchingItem?.Low}
                                title={item1.title}
                                exparydate={item1.expire_date}
                                token={item1.instrument_token}
                                catid={item1.category_id}
                              />
                            );
                          })}
                        {activeSearchBar === 2 &&
                          nscwatch.map((item1) => {
                            const matchingItem = live.find(
                              (item2) =>
                                item2.InstrumentIdentifier ==
                                item1.instrument_token,
                            );
                            return (
                              <Nscwatchlist
                                changeprice={matchingItem?.PriceChange}
                                percentagepricechange={
                                  matchingItem?.PriceChangePercentage
                                }
                                buy={matchingItem?.BuyPrice}
                                sell={matchingItem?.SellPrice}
                                ltp={matchingItem?.LastTradePrice}
                                high={matchingItem?.High}
                                low={matchingItem?.Low}
                                title={item1.title}
                                exparydate={item1.expire_date}
                                token={item1.instrument_token}
                                catid={item1.category_id}
                              />
                            );
                          })}
                        {activeSearchBar === 3 &&
                          mcx.map((item1) => {
                            const matchingItem = live.find(
                              (item2) =>
                                item2.InstrumentIdentifier ==
                                item1.instrument_token,
                            );

                            return (
                              <Mcxlist
                                mcx={mcx}
                                live={live}
                                buy={matchingItem?.BuyPrice}
                                sell={matchingItem?.SellPrice}
                                ltp={matchingItem?.LastTradePrice}
                                high={matchingItem?.High}
                                low={matchingItem?.Low}
                                title={item1.title}
                                exparydate={item1.expire_date}
                                lotsize={item1.QuotationLot}
                                keyvalue={item1.category_id}
                                categotyid={item1.category_id}
                                checked1={item1.is_checked}
                                token={item1.instrument_token}
                                searchTerm={searchTerm}
                              />
                            );
                          })}
                        {activeSearchBar === 4 &&
                          nsc.map((item1) => {
                            const matchingItem = live.find(
                              (item2) =>
                                item2.InstrumentIdentifier ==
                                item1.instrument_token,
                            );
                            return (
                              <Nsclist
                                buy={matchingItem?.BuyPrice}
                                sell={matchingItem?.SellPrice}
                                ltp={matchingItem?.LastTradePrice}
                                high={matchingItem?.High}
                                low={matchingItem?.Low}
                                title={item1.title}
                                exparydate={item1.expire_date}
                                lotsize={item1.QuotationLot}
                                keyvalue1={item1.category_id}
                                categotyid={item1.category_id}
                                token={item1.instrument_token}
                                checked1={item1.is_checked}
                              />
                            );
                          })}
                        {activeSearchBar === 7 &&
                          Allmarketdatawatch.map((item1) => {
                            const matchingItem = live.find(
                              (item2) =>
                                item2.InstrumentIdentifier ===
                                item1.instrument_token,
                            );
                            return (
                              <Allmarketwatch
                                changeprice={matchingItem?.PriceChange}
                                percentagepricechange={
                                  matchingItem?.PriceChangePercentage
                                }
                                buy={matchingItem?.BuyPrice}
                                sell={matchingItem?.SellPrice}
                                ltp={matchingItem?.LastTradePrice}
                                high={matchingItem?.High}
                                low={matchingItem?.Low}
                                title={item1.title}
                                exparydate={item1.expire_date}
                                token={item1.instrument_token}
                                catid={item1.category_id}
                              />
                            );
                          })}

                        {/* {activeSearchBar === 20 && (
                          <Optionchain data={option} nsedata={data} />
                        )} */}

                        {activeSearchBar == 20 && (
                          <div className="optionchain">
                            <Link>
                              <div
                                className="option-card"
                                // style={{
                                //   backgroundColor: "#c5e0e1",
                                //   borderTop: "1px solid",
                                // }}
                                onClick={() => {
                                  {
                                    handleButtonClick(21);
                                  }
                                }}
                              >
                                <i className="fa-solid fa-arrow-trend-up"></i>
                                <h3>NIFTY</h3>
                                <p>Option Chain</p>
                                {/* <Link
                                className="fa-solid fa-arrow-trend-up"
                                id="others"
                                type="button"
                                role="tab"
                                aria-controls="others-tabs"
                                aria-selected="true"
                              >
                                NIFTY OPTION CHAIN
                              </Link> */}
                              </div>
                            </Link>
                            <Link>
                              <div
                                className="option-card bank"
                                // style={{
                                //   backgroundColor: "#c5e0e1",
                                //   borderTop: "1px solid",
                                //   borderBottom: "1px solid",
                                // }}
                                onClick={() => {
                                  {
                                    handleButtonClick(22);
                                  }
                                }}
                              >
                                {" "}
                                <i className="fa-solid fa-building-columns"></i>
                                <h3>BANK NIFTY</h3>
                                <p>Option Chain</p>
                                {/* <Link
                                style={{ textAlign: "center" }}
                                className="fa-solid fa-building-columns"
                                type="button"
                                role="tab"
                                aria-controls="futures-tabs"
                                aria-selected="true"
                              >
                                BANK NIFTY OPTION CHAIN
                              </Link> */}
                              </div>
                            </Link>
                          </div>
                        )}

                        {/* {activeSearchBar == 20 && (
                          <div
                            className=" "
                            style={{
                              backgroundColor: "#c5e0e1",
                              borderTop: "1px solid",
                              borderBottom: "1px solid",
                            }}
                          >
                            {" "}
                            <Link
                              style={{ textAlign: "center" }}
                              className="btn btn-default btn-block"
                              type="button"
                              role="tab"
                              aria-controls="futures-tabs"
                              aria-selected="true"
                              onClick={() => {
                                {
                                  handleButtonClick(22);
                                }
                              }}
                            >
                              BANK NIFTY OPTION CHAIN
                            </Link>
                          </div>
                        )} */}

                        {activeSearchBar === 21 && (
                          <Mcxnfo data={option} nsedata={live} />
                        )}
                        {activeSearchBar === 22 && (
                          <Banknifty data={option} nsedata={live} />
                        )}
                        {/* {activeSearchBar === 20 &&
                          ce.map((item) => {
                            return <Mcxnfo data={ce} />;
                          })} */}
                        {/* {activeSearchBar === 8 && <Extra />}
                            {activeSearchBar === 7 && <Others />}
                            {activeSearchBar === 10 && <Others />} */}
                        <div
                          className="tab-pane fade"
                          id="others-tabs"
                          role="tabpanel"
                          aria-labelledby="others"
                        >
                          <div className="tab_search_body"></div>
                        </div>
                      </div>
                    </div>
                    <Theme />
                    <Nav stopfuntion={stopFunctionCall} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default Home;
